// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* container + responsive two-column layout */
.clv-wrap {
  width: 100%;
}
.clv-grid {
  display: grid;
  grid-template-columns: 1fr; /* default: single column */
  gap: 16px;
  align-items: start;
}

/* two columns only when there is room (desktop/tablet) */
@media (min-width: 1024px) {
  .clv-grid {
    grid-template-columns: 1fr 1fr;
  }
}

/* section header */
.clv-title {
  margin: 0 0 8px 0;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: .6px;
  font-weight: 800;
}

/* table shell */
.clv-table {
  border-radius: 14px;
  overflow: hidden;
}

/* header row */
.clv-thead {
  display: grid;
  grid-template-columns: 4fr 1.5fr 1.6fr 1.5fr;
  color: #fff;
}
.clv-th {
  padding: 10px 12px;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: .4px;
}

/* body rows */
.clv-tbody {
  display: block;
}
.clv-tr {
  display: grid;
  grid-template-columns: 4fr 1.5fr 1.6fr 1.5fr;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,.06);
}
.clv-tr:last-child {
  border-bottom: none;
}

.clv-td {
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clv-titlecell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.clv-roomcell {
  display: flex;
  align-items: center;
}
.clv-timecell,
.clv-leftcell {
  text-align: left;
}

.clv-empty {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 16px 12px;
  border: 1px dashed;
  margin: 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}
.clv-empty .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* small screens: make columns tighter */
@media (max-width: 480px) {
  .clv-thead,
  .clv-tr {
    grid-template-columns: 3fr 1.7fr 1.7fr 1.4fr;
  }
  .clv-td { font-size: 12px; }
}

/* helpful utility */
.muted { opacity: .7; }
`, "",{"version":3,"sources":["webpack://./src/Components/CourseListView.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,0BAA0B,EAAE,2BAA2B;EACvD,SAAS;EACT,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE;;IAEE,4CAA4C;EAC9C;EACA,UAAU,eAAe,EAAE;AAC7B;;AAEA,oBAAoB;AACpB,SAAS,WAAW,EAAE","sourcesContent":["/* container + responsive two-column layout */\n.clv-wrap {\n  width: 100%;\n}\n.clv-grid {\n  display: grid;\n  grid-template-columns: 1fr; /* default: single column */\n  gap: 16px;\n  align-items: start;\n}\n\n/* two columns only when there is room (desktop/tablet) */\n@media (min-width: 1024px) {\n  .clv-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* section header */\n.clv-title {\n  margin: 0 0 8px 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  letter-spacing: .6px;\n  font-weight: 800;\n}\n\n/* table shell */\n.clv-table {\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n/* header row */\n.clv-thead {\n  display: grid;\n  grid-template-columns: 4fr 1.5fr 1.6fr 1.5fr;\n  color: #fff;\n}\n.clv-th {\n  padding: 10px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  letter-spacing: .4px;\n}\n\n/* body rows */\n.clv-tbody {\n  display: block;\n}\n.clv-tr {\n  display: grid;\n  grid-template-columns: 4fr 1.5fr 1.6fr 1.5fr;\n  align-items: center;\n  border-bottom: 1px solid rgba(0,0,0,.06);\n}\n.clv-tr:last-child {\n  border-bottom: none;\n}\n\n.clv-td {\n  padding: 10px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.clv-titlecell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.clv-roomcell {\n  display: flex;\n  align-items: center;\n}\n.clv-timecell,\n.clv-leftcell {\n  text-align: left;\n}\n\n.clv-empty {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  padding: 16px 12px;\n  border: 1px dashed;\n  margin: 10px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.clv-empty .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n/* small screens: make columns tighter */\n@media (max-width: 480px) {\n  .clv-thead,\n  .clv-tr {\n    grid-template-columns: 3fr 1.7fr 1.7fr 1.4fr;\n  }\n  .clv-td { font-size: 12px; }\n}\n\n/* helpful utility */\n.muted { opacity: .7; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
